<script setup lang="ts">
import type { EsFilterDefaultFragment, EsFilterRangeFragment } from '#graphql-operations'

type ActiveFilter = (EsFilterDefaultFragment | EsFilterRangeFragment) & {
  options?: Array<{
    key: string
    label: string
    active?: boolean
  }>
}

const { t: $t } = useI18n()

defineProps<{
  activeFilters: Record<string, ActiveFilter>
}>()

defineEmits(['filters-reset-all', 'filter-reset-range', 'option-toggle'])
</script>

<template>
  <div class="filter-active">
    <div class="filter__heading">
      {{ $t('Filters') }}
    </div>

    <ol
      v-if="activeFilters.length"
      class="filter-active__list"
      :aria-label="$t('Active filters')"
    >
      <template
        v-for="filter in activeFilters"
        :key="filter.key"
      >
        <li
          v-if="filter.type === 'range'"
          class="filter-active__item"
        >
          <button
            type="button"
            class="filter-active__link"
            @click="$emit('filter-reset-range', filter.key);"
          >
            {{ $t(filter.label) }}:&nbsp;

            <span v-if="filter?.minSelected">
              van
              <template v-if="filter.key?.includes('price')">€</template>
              {{ filter.minSelected }}
              <template v-if="!filter.key?.includes('price')">cm</template>&nbsp;
            </span>

            <span v-if="filter?.minSelected && filter?.maxSelected">-&nbsp;</span>

            <span v-if="filter?.maxSelected">
              tot
              <template v-if="filter.key?.includes('price')">€</template>
              {{ filter.maxSelected }}
              <template v-if="!filter.key?.includes('price')">cm</template>
            </span>
            <NuxtIcon name="icon:close" />
          </button>

          <!-- <pre>filter: {{ filter }}</pre> -->
        </li>
        <template v-else>
          <template
            v-for="option in filter.options"
            :key="option"
          >
            <li class="filter-active__item">
              <button
                v-if="option?.active"
                type="button"
                class="filter-active__link"
                @click="$emit('option-toggle', filter.key, option.key)"
              >
                <span>{{ $t(filter.label) }}:&nbsp;<span class="filter-active__option">{{ $t(option.label) }}</span></span>
                <NuxtIcon name="icon:close" />
              </button>
            </li>
          </template>
        </template>
      </template>
    </ol>

    <button
      v-if="activeFilters.length"
      type="button"
      class="filter-active__clear"
      @click="$emit('filters-reset-all')"
    >
      <span>{{ $t('Remove Filters') }}</span>
    </button>

    <!-- <pre>activeFilters: {{ activeFilters }}</pre> -->
  </div>
</template>

<style>
  @import url("~layers/components/Filter/Active.css");
</style>
